export type ChatSuggestedSurface = "chat_empty" | "chat_sparse";

export const chatKeys = {
  all: ["chat-hub"] as const,
  requestContext: () => [...chatKeys.all, "request-context"] as const,
  threadAll: ["chat-thread-hub"] as const,
  threadRequestContext: () =>
    [...chatKeys.threadAll, "request-context"] as const,
  threadContext: (chatId: number) =>
    [...chatKeys.threadAll, "thread-context", chatId] as const,
  userChats: (tab: "all" | "archived" = "all") => ["userChats", tab] as const,
  totalUnreadCount: () => ["totalUnreadCount"] as const,
  hiiveChat: (hiiveId: number) => ["hiiveChat", hiiveId] as const,
  chatMessages: (chatId: number) => ["chat", chatId, "messages"] as const,
  chatInfo: (chatId: number) => ["chat", chatId, "info"] as const,
  pinnedMessages: (chatId: number) => ["chat", chatId, "pinned"] as const,
  chatTypingUsers: (chatId: number) => ["chat", chatId, "typing"] as const,
  usersPresence: (userIds: string[]) =>
    ["chat", "presence", ...[...userIds].sort()] as const,
  searchTargets: (query: string) =>
    [...chatKeys.all, "search-targets", query] as const,
  chatSeenBy: (messageId: number) =>
    ["chat", "message", messageId, "seen"] as const,
  messageReactors: (messageId: number) =>
    ["chat", "message", messageId, "reactors"] as const,
  groupMembers: (chatId: number) => ["chat", chatId, "members"] as const,
  suggestedPeople: (surface: ChatSuggestedSurface) =>
    [...chatKeys.all, "suggested-people", surface] as const,
};
